import { Component, signal } from '@angular/core'
import { Subject, takeUntil, throttleTime } from 'rxjs'
import { LocationService } from 'src/app/core/services/location.service'
import { MapService } from 'src/app/core/services/map.service'
import { Marker } from 'maplibre-gl'

@Component({
  selector: 'app-map-navigation',
  templateUrl: './map-navigation-base.component.html',
  styleUrls: ['./map-navigation-base.component.scss'],
  standalone: false,
})
export class MapNavigationComponent {
  public rotateIcon = signal(0)
  public isLocationRefreshEnabled = signal(false)
  private cleanUp$ = new Subject<void>()
  private marker: Marker

  constructor(
    public readonly mapService: MapService,
    private locationService: LocationService,
  ) {
    const el = document.createElement('div')
    el.className = 'position-circle-marker'
    el.id = 'marker1'
    this.marker = new Marker(el)

    this.mapService.map.on('rotate', () => {
      this.rotateIcon.set(this.mapService.map.getBearing())
    })
  }

  toggleAutoRefresh = async () => {
    const enabled = !this.isLocationRefreshEnabled()
    this.isLocationRefreshEnabled.set(enabled)

    if (enabled) {
      this.locationService.initialize()
      this.locationService.configure()

      this.locationService.positionChanged$
        .pipe(throttleTime(5000, undefined, { leading: true, trailing: true }))
        .pipe(takeUntil(this.cleanUp$))
        .subscribe((position) => {
          if (this.isLocationRefreshEnabled()) {
            this.marker.remove()
            this.mapService.map.easeTo({
              center: position.exact,
              bearing: this.locationService.getHeading() || 0,
            })
            this.marker.setLngLat(position.exact).addTo(this.mapService.map)
          }
        })
    } else {
      this.isLocationRefreshEnabled.set(false)
      this.locationService.stopWatchingPosition()
      this.marker.remove()
      this.cleanUp$.next()
    }
  }

  ngOnDestroy(): void {
    this.locationService.stopWatchingPosition()
    this.marker.remove()
  }

  rotateNorth() {
    this.mapService.map.resetNorthPitch()
  }

  switchSatelliteView() {
    this.mapService.switchSatelliteView()
  }
}
